module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-25-Inactive-Rumble-f17fbffd1e166bd5c93ff0cb49196e45.png";